require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./classements-internationaux-0-0-6.json") })
        }
      }, "path---classements-internationaux-0-0-6");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---classements-internationaux-0-0-6!./.cache/json/classements-internationaux-0-0-6.json
// module id = 372
// module chunks = 231608221292675